import React, { useEffect, useState, Fragment } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import makeAnimated from 'react-select/animated';
import Editor from '@app/components/text-editor';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import handleStatus from '../../utils/ajax';
import { logoutUser } from '../../store/reducers/auth';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Formik, Field, useFormik } from 'formik';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as yup from 'yup';
import DropZone from '../../components/dropzone/DropZone';
import Comment from '@app/components/comment/Comment';
import {
  getAllUsers,
  getTaskById,
  getMyProjects,
  updateTask,
  addComment,
  allCommnets,
  logTime,
  getIssueByTaskId,
  fileRemoveHandler
} from '../../services/tasks';
import { Loader, LogTimeTrackingSection } from '@app/components';

interface EstimateInputRef {
  value: string;
  onChange: () => {};
  onBlur: () => {};
  isError: boolean;
  error: string
}

interface UserOption {
  value: string;
  label: string
}

interface Project {

}

interface ViewUpdateTaskRef {
  show: boolean;
  onHide: () => {};
  getTasks: () => {};
  searchValues: () => {};
  allUsers: UserOption[];
  projects: any;
}

interface AssignedTo {
  name: string;
  _id: string;
  profile: string;
}

interface TimeSpent {
  time: string;
  date: string;
}


interface Task {
  title: string;
  description: string;
  estimateTime: string;
  priority: string;
  issueType: string;
}

interface SubmitPayloadRef {
  title: string;
  status: boolean;
  estimateTime: string;
  priority: string;
  issueType: string;
  projectId: string;
}



const EstimateInput: React.FC<EstimateInputRef> = ({ value, onChange, onBlur, isError, error }) => {
  return (
    <>
      <input
        type="text"
        className="form-control"
        name="estimateTime"
        placeholder={'Enter like 2h 30m'}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      {isError && error ? (
        <p className="text-danger">{error}</p>
      ) : null}
    </>
  );
};



const ViewUpdateTask: React.FC<ViewUpdateTaskRef> = (props: any) => {
  const [initialValues, setInitialValues] = useState({
    title: '',
    issueType: '',
    description: '',
    assignedTo: [],
    project: '',
    priority: '',
    estimateTime: null
  });

  const [formValues, setFormValues] = useState<any>({});
  const [description, setDiscription] = useState<string>('');
  const [assignedTo, setAssignedTo] = useState([]);
  const [issueDescription, setIssueDescription] = useState('');
  const [myProject, setMyProject] = useState({});
  const [comment, setComment] = useState('');
  const [comments, setComments] = useState([]);
  const [createdAt, setCreatedAt] = useState<string>(null);
  const animatedComponents = makeAnimated();
  const [attachments, setAttachments] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const { show, onHide, getTasks, searchValues, allUsers, projects } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const issueId = localStorage.getItem('TASKID');
  const projectId = localStorage.getItem('TaskProjectId');
  const loggedInId = useSelector(
    (state: any) => state.auth.currentUser.data._id
  );

  const removeHandler = async (file: any) => {
    const { _id, fileHash } = file;
    const resp = await fileRemoveHandler(_id);
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);

    if (resp.status === 200) {
      const filtered = attachments.filter(
        (item: any) => item.fileHash !== fileHash
      );
      toast.success('File Deleted!');
      setAttachments(filtered);
    }
  };

  useEffect(() => {
    if (Object.keys(formValues).length !== 0) {
      const { title, issueType, estimateTime, priority } = formValues;
      setFormValues({
        title: title,
        issueType: issueType,
        estimateTime: estimateTime,
        priority: priority,
        description: formValues.description
      });
    }
  }, []);

  const getcomments = async (id: any, projectId: string) => {
    const resp = await allCommnets(id, projectId);
    if (resp.status === 200) {
      setComments(resp.data.data);
    }
  };

  const commentHandler = async () => {
    console.log(issueId, projectId, '----------taskno commentHandler and comments-----------', comment)
    const resp = await addComment(issueId, comment, projectId);
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);

    if (resp && !resp.data?.ok) {
      toast.warn(resp?.data?.message || 'Error while creating comment');
      setComment('');
      getcomments(issueId, projectId);
      return
    }
    toast.success(resp?.data?.message || 'Comment created successfully');
    setComment('');
    getcomments(issueId, projectId);
  };

  const getAllData = async (id: any, projectId: string) => {
    setShowLoader(true);
    const task = await getTaskById(id, projectId);
    // console.log('**********task.data.data************', task);
    handleStatus(task.status, () => dispatch(logoutUser()), navigate);
    if (task.data.ok) {
      setAssignedTo(
        task.data.data.assignedTo.map((val: any) => {
          return { value: val._id, label: val.name };
        })
      );

      // console.log('**********task.data.data************', task.data.data);
      setDiscription(task.data.data.description);
      setFormValues(task.data.data);
      setIssueDescription(task.data.data.description);
      setCreatedAt(task.data.data.created_At)

      const files = await getIssueByTaskId(task.data.data._id);
      handleStatus(files.status, () => dispatch(logoutUser()), navigate);
      setAttachments(files.data.data);
      console.log(task?.data?.data?.taskNo, task?.data?.data?.projectId, "project id and task no==============")
      const comments = await allCommnets(task?.data?.data?.taskNo, task?.data?.data?.projectId);
      handleStatus(comments.status, () => dispatch(logoutUser()), navigate);
      if (comments.status === 200) {
        setComments(comments.data.data);
      }
    }
    setShowLoader(false);
  };

  function formatTimestamp(timestamp: number) {
    // Assuming the timestamp is in a format that can be parsed by Date in JavaScript
    const date = new Date(timestamp);
    return format(date, "d MMMM, yyyy p");
  }
  useEffect(() => {
    if (issueId && projectId) {
      getAllData(issueId, projectId);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(formValues).length > 0 && projects.length > 0) {
      setMyProject(
        projects.filter((pro: any) => pro._id === formValues.projectId)[0]
      );
    }
  }, [projects, formValues]);

  const parseHoursNMinutes = (inputValue: string) => {
    return inputValue
      .split(/[hHmM]/)
      .filter(Boolean)
      .map(Number);
  }

  function validateTaskEstimate(inputValue: string, initialSave: boolean) {
    const regex = /^(\d{1,2}h(\d{1,2}m)?)?$/; // Regex to match XhYm format

    if (!inputValue.trim()) {
      return "Input can't be blank.";
    }

    if (!regex.test(inputValue)) {
      return 'Invalid format. Use XhYm, e.g., 2h30m.';
    }

    if (initialSave) {
      return null;
    }

    const [hours, minutes] = parseHoursNMinutes(inputValue);

    if (hours > 4) {
      return 'Maximum task duration is 4 hours.';
    }

    if (minutes > 60) {
      return 'Minutes should not exceed 60.';
    }

    if (minutes > 1 && minutes < 10 && hours === 0) {
      return 'Minimum task duration is 10 minutes.';
    }

    return null; // Validation passed
  }



  const validate = (values: Task) => {
    const errors: any = {};

    let { title, priority, estimateTime, issueType, description } = values;
    if (!issueType || issueType.trim() === '') {
      errors.issueType = 'Required!';
    }
    if (!title || title.trim() === '') {
      errors.title = 'Required!';
    }

    if (!priority || priority.trim() === '') {
      errors.priority = 'Required!';
    }
    if (
      description.trim() === '' ||
      description.trim().match(/[^'<p><br></p>']/g) === null
    ) {
      errors.description = 'Required!';
    }

    if (assignedTo.length === 0 || assignedTo === []) {
      errors.assignedTo = 'Required';
    }

    const resp = validateTaskEstimate(estimateTime, false);

    if (resp) {
      errors.estimateTime = resp;
    }

    return errors;
  };

  const onSubmit = async (values: SubmitPayloadRef) => {
    if (description.trim().match(/[^'<p><br></p>']/g) == null) {
      toast.error('Please enter descripton!');
      return;
    }

    if (assignedTo.length === 0) {
      toast.error('Please assign task!');
      return;
    }

    const { title, issueType, priority, estimateTime, status, projectId } =
      values;
    const [oldHours, oldMins] = parseHoursNMinutes(formValues.estimateTime);
    const [newHours, newMins] = parseHoursNMinutes(estimateTime);
    const oldTotalMins = (oldHours * 60) + oldMins;
    const newTotalMins = (newHours * 60) + newMins;

    if (oldTotalMins > 0 && (newTotalMins > oldTotalMins)) {
      return toast.error("You can't increase the original estimate")
    }

    const modifiedValues = {
      title,
      estimateTime,
      issueType,
      priority,
      status,
      projectId,
      description,
      assignedTo:
        assignedTo.length > 0 && assignedTo.map((user: any) => user.value)
    }

    const resp = await updateTask(modifiedValues, formValues._id);
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
    if (resp.status === 200) {
      getTasks(searchValues);
      onHide();
      toast.success('Task updated successfully...');
      navigate('/tasks');
      return;
    }
  };

  const { values, errors, touched, handleSubmit, handleBlur, handleChange }: any =
    useFormik({
      initialValues: formValues,
      enableReinitialize: true,
      validate,
      onSubmit
    });

  const parseHoursAndMinutes = (time: string) =>
    time
      .split(/[hHmM]/)
      .filter(Boolean)
      .map(Number);

  const getTotalTime = () => {
    const { estimateTime } = formValues;
    if (!estimateTime) {
      return 0;
    }

    const [hours, minutes] = parseHoursAndMinutes(estimateTime);

    return (hours * 60) + minutes;
  }

  const getLoggedTime = () => {
    const { timeSpent } = formValues;
    if (!timeSpent) {
      return 0;
    }

    if (timeSpent && timeSpent.length === 0) {
      return 0;
    }

    let totalTimeInMinutes = 0;

    timeSpent.forEach((time: string) => {
      const [hours = 0, minutes = 0] = parseHoursAndMinutes(time.time);
      // console.log("(((((((((((((", hours, minutes)

      totalTimeInMinutes += hours * 60 + minutes;
    });

    return totalTimeInMinutes;
  };

  return (
    <>
      {show && (
        <Modal
          {...props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show
          onHide={onHide}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {showLoader ? "Loading..." : (
                <div>
                  {values.taskNo}/
                  {values.title ? values.title.substring(0, 50) : null}
                  <CopyToClipboard
                    text={`${window.location.origin}/tasks/${values.projectId}/${values.taskNo}`}
                    onCopy={() => toast.success('Link Copied!')}
                  >
                    <button className="btn btn-primary btn-sm ml-2">
                      Copy Link
                    </button>
                  </CopyToClipboard>
                </div>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {showLoader ? (
              <Loader title={'Daily'} />
            ) : (
              <div className="d-flex flex-row justify-content-between">
                <div style={{ width: '50%' }} className="pe-4">
                  <form onSubmit={handleSubmit}>
                    <div className="card-body">
                      <div className="form-group">
                        <div className="col-lg my-2">
                          <label>Issue Type</label>
                          <select
                            name="issueType"
                            className="form-control"
                            value={values.issueType}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option defaultChecked value=""></option>
                            <option value="task">Task</option>
                            <option value="bug">Bug</option>
                            <option value="testing">Testing</option>
                            <option value="r&d">R&D</option>
                          </select>

                          {touched.issueType && errors.issueType ? (
                            <p className="text-danger">{errors.issueType}</p>
                          ) : null}
                        </div>
                        <div className="col-lg my-2">
                          <label>Title </label>
                          <input
                            type="title"
                            placeholder="Enter title"
                            className="form-control"
                            name="title"
                            value={values.title}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {touched.title && errors.title ? (
                            <p className="text-danger">{errors.title}</p>
                          ) : null}
                        </div>
                        <div className="col-lg  my-2">
                          <label>Description</label>
                          <Editor
                            onChange={(e) => setDiscription(e)}
                            value={issueDescription}
                          />
                          {errors.description ? (
                            <p className="text-danger">{errors.description}</p>
                          ) : null}
                        </div>

                        <div className="col-lg my-4 ">
                          <label>Upload Files</label>
                          <DropZone
                            taskId={values._id}
                            setAttachments={setAttachments}
                            attachments={attachments}
                            removeHandler={removeHandler}
                            mode="Update"
                          />
                        </div>
                        <div className="col-lg  my-2">
                          <label>Assigned To</label>

                          <Select
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            defaultValue={[]}
                            value={assignedTo}
                            onChange={(e) => setAssignedTo([e])}
                            options={allUsers}
                            onBlur={handleBlur}
                          />
                          {errors.assignedTo ? (
                            <p className="text-danger">{errors.assignedTo}</p>
                          ) : null}
                        </div>
                        <div className="col-lg  my-2">
                          <label>Project</label>
                          <select
                            name="projectId"
                            className="form-control"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled
                          >
                            {myProject && Object.keys(myProject).length > 0 && (
                              <option value={myProject?._id}>
                                {myProject?.projectName}
                              </option>
                            )}
                          </select>{' '}
                          {touched.projectId && errors.projectId ? (
                            <p className="text-danger">{errors.projectId}</p>
                          ) : null}
                        </div>
                        <div className="col-lg my-2">
                          <label>Priority</label>
                          <select
                            name="priority"
                            className="form-control"
                            defaultValue={values.priority}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="">--None--</option>
                            <option value="low">Low</option>
                            <option value="medium">Medium</option>
                            <option value="urgent">Urgent</option>
                          </select>
                          {touched.priority && errors.priority ? (
                            <p className="text-danger">{errors.priority}</p>
                          ) : null}
                        </div>
                        <div className="col-lg my-2">
                          <label>Estimate Time</label>
                          <EstimateInput
                            value={values.estimateTime}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isError={touched.estimateTime}
                            error={errors.estimateTime}
                          />
                        </div>
                        <div className="col-lg mt-4 d-flex">
                          <Button
                            className="mx-3"
                            type="submit"
                            variant="primary"
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div style={{ width: '50%' }} className="p-5">
                  <h4>Add a Comment!</h4>
                  <form className="d-flex flex-column my-2">
                    <textarea
                      style={{ height: '100px', outline: 'blue' }}
                      name="text"
                      onChange={(e) => setComment(e.target.value)}
                      value={comment}
                    />

                    <div>
                      <Button
                        className="my-2"
                        type="button"
                        onClick={commentHandler}
                        variant="primary"
                      >
                        Save
                      </Button>
                    </div>
                  </form>

                  <div>
                    <h5 className="my-2"> All Comments</h5>
                    <div
                      style={{
                        background: 'white',
                        height: '358px',
                        overflowX: 'hidden',
                        overflowY: 'scroll',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        padding: '10px'
                      }}
                      className="my-2 d-flex flex-column"
                    >
                      {comments.map((comment: any, index) => {
                        let isEditable = false;
                        const elapsedTime = +Date.now() - comment.created_At;
                        const elapsedTimeInSeconds = Math.floor(elapsedTime / 1000);
                        const totalSecondsIn30Mins = 30 * 60;

                        if (loggedInId === comment.createdBy._id && elapsedTimeInSeconds <= totalSecondsIn30Mins) {
                          isEditable = true;
                        }

                        return (
                          <Comment
                            key={index}
                            text={comment.text}
                            id={comment._id}
                            isEditable={isEditable}
                            issueId={issueId}
                            getcomments={getcomments}
                            userName={comment.createdBy.name}
                            created_At={comment.created_At}
                          />
                        );
                      })}
                    </div>
                    <LogTimeTrackingSection
                      loggedTimeValue={getLoggedTime()}
                      totalTimeValue={getTotalTime()}
                      projectId={formValues.projectId}
                      taskId={formValues._id}
                      onLogTime={() => getAllData(issueId, projectId)}
                    />
                    <div>
                      <span className='text-bold mt-2 d-flex'>Create At: {formatTimestamp(createdAt)}</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default ViewUpdateTask;
